export default __webpack_public_path__ + "static/media/time.0b986dfb.svg";